/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../../types/schema.generated';

import gql from 'graphql-tag';
import { ChatPageHeaderMemoFragmentDoc } from '../ChatPageHeader.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type ChatRoomStatus =
  /** 要対応(OA向けに作ったものだが、一般にも使えるようなenumにする) */
  | 'ActionRequired'
  /** 面談済み・対応中 */
  | 'Appointed'
  /** 対応不要 */
  | 'Archived'
  /** 契約済み */
  | 'ContractConcluded'
  /** 保険契約済み */
  | 'ContractConcludedInsurance'
  /** 証券契約済み */
  | 'ContractConcludedSecurities'
  /** 不満足の表明(OA向けに作ったものだが、一般にも使えるようなenumにする) */
  | 'GotComplaints'
  /** 後追い対応 */
  | 'Keeping'
  /** 失注 */
  | 'LostOrder'
  /** チャット対応中 */
  | 'Messaging'
  /** 未設定 */
  | 'NotDefined'
  /** 面談設定中 */
  | 'Offering'
  /** 初回面談実施待ち */
  | 'WaitingForFirstAppointment';

export type PersonalityType =
  | 'A'
  | 'B'
  | 'C'
  | 'D'
  | 'E'
  | 'F'
  | 'G'
  | 'H';

export type RankInCluster =
  | 'A'
  | 'B'
  | 'C'
  | 'D'
  | 'E'
  | 'UNSPECIFIED';

export type StaffRole =
  | 'BRANCH_MANAGER'
  | 'CORPORATION_ADMIN'
  | 'ENTRANCE_MANAGER'
  | 'MEMBER';

export type DiagnosisByUserDetailFragment = { personality: { type: Types.PersonalityType, title: string, description: string }, cards: { annualIncome: { name: string, title: string, rank: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean }, savingAnnual: { name: string, title: string, rank: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean }, monthlyRentCost: { name: string, title: string, rank: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean }, investment: { name: string, title: string, rank: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean }, monthlyInsurance: { name: string, title: string, rank: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean } } };

export type ChatRoomQueryVariables = Exact<{
  id: string | number;
}>;


export type ChatRoomQuery = { ownChatRoom: { id: string, status: Types.ChatRoomStatus, memos: Array<{ id: string, content: string, createdAt: TimeString }>, user: { lineActivationUser: { isBlocked: boolean } | null } | null } | null, viewer: { is400FOA: boolean, hasLineActivationProvider: boolean, staff: { role: Types.StaffRole } } };

export type DiagnosisByUserQueryVariables = Exact<{
  userId: string | number;
}>;


export type DiagnosisByUserQuery = { diagnosisByUser: { personality: { type: Types.PersonalityType, title: string, description: string }, cards: { annualIncome: { name: string, title: string, rank: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean }, savingAnnual: { name: string, title: string, rank: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean }, monthlyRentCost: { name: string, title: string, rank: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean }, investment: { name: string, title: string, rank: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean }, monthlyInsurance: { name: string, title: string, rank: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean } } } };

export const DiagnosisByUserDetailFragmentDoc = gql`
    fragment diagnosisByUserDetail on DiagnosisByUser {
  personality {
    type
    title
    description
  }
  cards {
    annualIncome {
      name
      title
      rank
      myValue
      averageValue
      unit
      message
      showBarGraph
    }
    savingAnnual {
      name
      title
      rank
      myValue
      averageValue
      unit
      message
      showBarGraph
    }
    monthlyRentCost {
      name
      title
      rank
      myValue
      averageValue
      unit
      message
      showBarGraph
    }
    investment {
      name
      title
      rank
      myValue
      averageValue
      unit
      message
      showBarGraph
    }
    monthlyInsurance {
      name
      title
      rank
      myValue
      averageValue
      unit
      message
      showBarGraph
    }
  }
}
    `;
export const ChatRoomDocument = gql`
    query chatRoom($id: ID!) {
  ownChatRoom(id: $id) {
    id
    status
    memos {
      ...ChatPageHeaderMemo
    }
    user {
      lineActivationUser {
        isBlocked
      }
    }
  }
  viewer {
    is400FOA
    staff {
      role
    }
    hasLineActivationProvider
  }
}
    ${ChatPageHeaderMemoFragmentDoc}`;

/**
 * __useChatRoomQuery__
 *
 * To run a query within a Vue component, call `useChatRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatRoomQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChatRoomQuery({
 *   id: // value for 'id'
 * });
 */
export function useChatRoomQuery(variables: ChatRoomQueryVariables | VueCompositionApi.Ref<ChatRoomQueryVariables> | ReactiveFunction<ChatRoomQueryVariables>, options: VueApolloComposable.UseQueryOptions<ChatRoomQuery, ChatRoomQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ChatRoomQuery, ChatRoomQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ChatRoomQuery, ChatRoomQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ChatRoomQuery, ChatRoomQueryVariables>(ChatRoomDocument, variables, options);
}
export function useChatRoomLazyQuery(variables?: ChatRoomQueryVariables | VueCompositionApi.Ref<ChatRoomQueryVariables> | ReactiveFunction<ChatRoomQueryVariables>, options: VueApolloComposable.UseQueryOptions<ChatRoomQuery, ChatRoomQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ChatRoomQuery, ChatRoomQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ChatRoomQuery, ChatRoomQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ChatRoomQuery, ChatRoomQueryVariables>(ChatRoomDocument, variables, options);
}
export type ChatRoomQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ChatRoomQuery, ChatRoomQueryVariables>;
export const DiagnosisByUserDocument = gql`
    query diagnosisByUser($userId: ID!) {
  diagnosisByUser(userId: $userId) {
    ...diagnosisByUserDetail
  }
}
    ${DiagnosisByUserDetailFragmentDoc}`;

/**
 * __useDiagnosisByUserQuery__
 *
 * To run a query within a Vue component, call `useDiagnosisByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiagnosisByUserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDiagnosisByUserQuery({
 *   userId: // value for 'userId'
 * });
 */
export function useDiagnosisByUserQuery(variables: DiagnosisByUserQueryVariables | VueCompositionApi.Ref<DiagnosisByUserQueryVariables> | ReactiveFunction<DiagnosisByUserQueryVariables>, options: VueApolloComposable.UseQueryOptions<DiagnosisByUserQuery, DiagnosisByUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DiagnosisByUserQuery, DiagnosisByUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DiagnosisByUserQuery, DiagnosisByUserQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DiagnosisByUserQuery, DiagnosisByUserQueryVariables>(DiagnosisByUserDocument, variables, options);
}
export function useDiagnosisByUserLazyQuery(variables?: DiagnosisByUserQueryVariables | VueCompositionApi.Ref<DiagnosisByUserQueryVariables> | ReactiveFunction<DiagnosisByUserQueryVariables>, options: VueApolloComposable.UseQueryOptions<DiagnosisByUserQuery, DiagnosisByUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DiagnosisByUserQuery, DiagnosisByUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DiagnosisByUserQuery, DiagnosisByUserQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DiagnosisByUserQuery, DiagnosisByUserQueryVariables>(DiagnosisByUserDocument, variables, options);
}
export type DiagnosisByUserQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DiagnosisByUserQuery, DiagnosisByUserQueryVariables>;